import React from 'react';
import { FadeIn } from './FadeIn';
export const MechanismSection = () => {
  const benefits = [{
    name: 'Energía',
    icon: '⚡'
  }, {
    name: 'Enfoque',
    icon: '🧠'
  }, {
    name: 'Digestión',
    icon: '🍃'
  }, {
    name: 'Recuperación',
    icon: '💪'
  }, {
    name: 'Anti-Estrés',
    icon: '🧘'
  }, {
    name: 'Detox',
    icon: '🌙'
  }, {
    name: 'Inmunidad',
    icon: '🛡️'
  }];
  return <section className="py-20 bg-dark" data-id="element-145">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-146">
        <FadeIn data-id="element-147">
          <h2 className="font-serif text-3xl md:text-4xl font-bold mb-8 text-center text-white" data-id="element-148">
            El Método 7x7:{' '}
            <span className="text-brand-green" data-id="element-149">Nutrición Dirigida</span>
          </h2>
        </FadeIn>
        <FadeIn delay={0.2} data-id="element-150">
          <p className="text-xl text-gray-300 leading-relaxed text-center max-w-3xl mx-auto mb-12" data-id="element-151">
            El método 7x7 es diferente. Cada batido está diseñado para un
            objetivo específico: energía estable, enfoque mental, digestión
            fluida, recuperación muscular, reducción de estrés, detox nocturno y
            refuerzo inmunitario. Además, cada batido se combina con un
            ejercicio exprés de 5 minutos para potenciar el efecto. Es nutrición
            dirigida y combinaciones probadas.
          </p>
        </FadeIn>

        <div className="flex flex-wrap justify-center gap-4" data-id="element-152">
          {benefits.map((benefit, index) => <FadeIn key={index} delay={0.3 + index * 0.1} data-id="element-153">
              <div className="bg-darker border border-brand-green/30 px-6 py-4 rounded-full flex items-center gap-2 hover:border-brand-green transition-colors" data-id="element-154">
                <span className="text-xl" data-id="element-155">{benefit.icon}</span>
                <span className="font-medium text-white" data-id="element-156">{benefit.name}</span>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
};